var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"warning-banner"},[_c('div',{class:[
            'warning-banner__container',
            {
                'warning-banner__container_small-sized': _vm.small,
                'warning-banner__container_for-mobile': _vm.mobile,
                'warning-banner__container_yellow': _vm.typeColor === 'yellow',
                'warning-banner__container_border-radius': _vm.borderRadius,
            }
        ]},[_c('i',{class:[
                'warning-banner__icon',
                {
                    'warning-banner__icon_small-sized': _vm.small,
                    'warning-banner__icon_red': _vm.typeColor === 'red',
                    'warning-banner__icon_yellow': _vm.typeColor === 'yellow',
                }
            ]}),_vm._v(" "),_c('div',{staticClass:"warning-banner__text"},[_c('div',{class:[
                    'warning-banner__main-text',
                    {
                        'warning-banner__main-text_for-mobile': _vm.mobile
                    }
                ]},[_vm._t("main-text")],2),_vm._v(" "),(_vm.$slots.description)?_c('div',{staticClass:"warning-banner__description",class:[
                    'warning-banner__description',
                    {
                        'warning-banner__description_for-mobile': _vm.mobile,
                    }
                ]},[_vm._t("description")],2):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }